import React, { useState } from "react";

export default function Button({
  children,
  onClick,
  type = "button",
  disabled = false,
  variant = "primary", // primary | secondary | danger
  width,
}) {
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(false);

  const variants = {
    primary: {
      background: hover
        ? "linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%)"
        : "linear-gradient(180deg, #3b82f6 0%, #2563eb 100%)",
      border: "#3b82f6",
    },
    secondary: {
      background: hover
        ? "linear-gradient(180deg, #374151 0%, #1f2937 100%)"
        : "linear-gradient(180deg, #4b5563 0%, #374151 100%)",
      border: "rgba(255,255,255,0.15)",
    },
    danger: {
      background: hover
        ? "linear-gradient(180deg, #dc2626 0%, #b91c1c 100%)"
        : "linear-gradient(180deg, #ef4444 0%, #dc2626 100%)",
      border: "#ef4444",
    },
  };

  const style = variants[variant] || variants.primary;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => {
        setHover(false);
        setActive(false);
      }}
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
      style={{
        padding: "10px 16px",
        borderRadius: 8,
        border: `1px solid ${style.border}`,

        background: style.background,

        color: "white",
        fontWeight: 600,
        fontSize: 14,

        cursor: disabled ? "not-allowed" : "pointer",

        boxShadow: active
          ? "inset 0 2px 4px rgba(0,0,0,0.4)"
          : "0 4px 12px rgba(0,0,0,0.25)",

        transform: active ? "scale(0.98)" : "scale(1)",

        transition: "all 0.15s ease",

        opacity: disabled ? 0.6 : 1,

        width,
      }}
    >
      {children}
    </button>
  );
}